import { Pipe, PipeTransform } from "@angular/core";
import { CategoriesData } from "../../providers/categories";
import { CheckInData } from "../../providers/checkIn";

@Pipe({
  name: "checkIn"
})
export class CheckInPipe implements PipeTransform {
  constructor(private checkInData: CheckInData ) {}

  transform(idUser: string, idClient: string, idEvent: string) {
    return this.checkInData.userHasCheckIn(idClient,idEvent,idUser);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/checkIn/checkIn.ts